module.exports = __webpack_public_path__ + "static/media/gcdef_124.789500bd.ico";